export enum DISPATCH_MODE {
  SHIP = 'ship',
  PICKUP_FROM_DEPOT = 'pickup_from_depot',
  HAND_OVER_TO_VENDOR = 'hand_over_to_vendor',
};